import React, { Component } from "react";
import Slide from "react-reveal";

class Resume extends Component {
  getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    if (!this.props.data) return null;

    const skillmessage = this.props.data.skillmessage;
    // const education = this.props.data.education.map(function (education) {
    //   return (
    //             <div key={education.school}>
    //                 <h3>{education.school}</h3>
    //                 <p className="info">
    //                   {education.degree} <span>&bull;</span>
    //                   <em className="date">{education.graduated}</em>
    //                 </p>
    //             <p>{education.description}</p>
    //         </div>
    //         );
    //  });

    const work = this.props.data.work.map(function (work) {
      return (
        <div key={work.work}>
          <h3>{work.work}</h3>
          <p className="info">
            {work.title}
            {/*<span>&bull;</span> <em className="date">{work.years}</em>*/}
          </p>
          <p>{work.description}</p>
        </div>
      );
    });

    const skills = this.props.data.skills.map((skills) => {
      const backgroundColor = this.getRandomColor();
      const className = "bar-expand " + skills.name.toLowerCase();
      const width = skills.level;

      return (
        <li key={skills.name}>
          <span style={{ width, backgroundColor }} className={className}></span>
          <em>{skills.name}</em>
        </li>
      );
    });

    return (
      <section id="resume">
        <Slide left duration={1300}>
          <div className="row education">
            <div className="three columns header-col">
              <h1>
                <span>Live Projects</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">
                  <a href="https://val-nft-collection.vercel.app/">
                    NFT Collection dApp
                  </a>
                  <p>
                    Project build with HardHat, Openzeppelin, EthersJs, NextJs
                    and Solidity.{" "}
                  </p>
                </div>

                <div className="twelve columns">
                  <a href="https://val-whitelist-dapp.vercel.app/">
                    Whitelist dApp
                  </a>
                  <p>
                    Project build with HardHat, Openzeppelin, EthersJs, NextJs
                    frontend and Solidity.{" "}
                  </p>
                </div>

                <div className="twelve columns">
                  <a href="https://ohukaiv.netlify.app/">
                    Flight and Hotel Booking App
                  </a>
                  <p>
                    This project is built on Reactjs frontend and Laravel for
                    backend.{" "}
                  </p>
                </div>

                <div className="twelve columns">
                  <a href="https://ohukaiv.netlify.app/">
                    Ohuka Ikenna Valentine | Portfolio
                  </a>
                  <p>
                    Superfast, Am I not? I should because my creator (Val) made
                    me with ReactJs only.{" "}
                  </p>
                </div>

                <div className="twelve columns">
                  <a href="https://mls.ebsgov.org/">
                    Ebonyi State Ministry of Lands Web App
                  </a>
                  {/* <p> </p> */}
                </div>
                <br />
                <div className="twelve columns">
                  <a href="https://irs.ebsgov.org/">
                    Ebonyi State Internal Revenue Service Web App
                  </a>
                  {/* <p>Avaliable on demand </p> */}
                </div>

                <div className="twelve columns">
                  <a href=" https://github.com/sirval/multi-user-login-api-with-laravel-socialite">
                    Login API with Laravel Socialite Package
                  </a>
                  <p>
                    {" "}
                    This an API developed with laravel 8. This API employs the
                    native Registration and Login platform coupled with Social
                    Media (Google, Facebook, Github and Twitter) Login. This was
                    achieved using Laravel Socialite package.{" "}
                    <a href="https://github.com/sirval/multi-user-login-api-with-laravel-socialite/blob/main/README.md">
                      <i>Read More</i>
                    </a>{" "}
                  </p>
                </div>

                <div className="twelve columns">
                  <a href="https://val-news-hub.herokuapp.com/">News Hub</a>
                  <p>
                    A simple News Application designed with PHP [Laravel 8] with
                    blades. Employing media SaaS API (Cloudinary) and multi
                    login with Remember Me functionality.{" "}
                  </p>
                </div>

                <div className="twelve columns">
                  <a href="https://materials.disqussion.com">Disqussion</a>
                  <p>
                    An academic platform providing undergrads with project
                    topics. Built with native php
                  </p>
                </div>

                <div className="twelve columns">
                  <a href="https://khsenugu.org">School Managment</a>
                  <p>
                    An academic platform providing a round the clock solution to
                    day to day to activities. Designed with native php
                  </p>
                </div>

                <div className="twelve columns">
                  <a href="https://cradletofame.com">Social Platform</a>
                  <p>A social platform. Designed with native php</p>
                </div>
              </div>
            </div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>Our works</span>
              </h1>
            </div>

            <div className="nine columns main-col">{work}</div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row skill">
            <div className="three columns header-col">
              <h1>
                <span>Skills</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <p>{skillmessage}</p>

              <div className="bars">
                <ul className="skills">{skills}</ul>
              </div>
            </div>
          </div>
        </Slide>
      </section>
    );
  }
}

export default Resume;
